export default "__VITE_ASSET__DucofNFj__"